import axios from 'axios';
import ShortUniqueId from 'short-unique-id';

const uid = new ShortUniqueId();

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

let fetchPromise = null;

export default {
    namespaced: true,

    state: {
        loaded: false,
        data: [],

    },
    getters: {
        pipeFromSizeAndType(state) {
            return (size, type) => {
                return state.data.find(i => (i.size == size && i.type == type));
            };
        },
        loaded(state) {
            return state.loaded;
        },
        types(state) {
            return [ ...new Set(state.data.map(i => i.type)) ];
        },
        sizes(state) {
            return [ ...new Set(state.data.map(i => parseFloat(i.size))) ];
        },

        typesFromSize(state) {
            return size => {
                //return [];
                return [ ...new Set(state.data.filter(i => i.size == size).map(i => i.type)) ];
            };
        },

        sizesFromType(state) {
            return type => {
                return [ ...new Set(state.data.filter(i => i.type == type).map(i => parseFloat(i.size))) ];
            };
        }
    },
    actions: {
        fetchPipes({commit}) {
            if (fetchPromise === null) {
                fetchPromise = axios.get('/actions/anvil-module/seismic-piping/retrieve-pipes')
                    .then(r => commit('set', r.data));
            }

            return fetchPromise;
        },
    },
    mutations: {
        set(state, data) {
            state.loaded = true;
            state.data = data;
        },
    },
};
